import {
  UpArrowGreen_Trend,
  UpArrowRed_Trend,
  UpArrowYellow_Trend,
} from 'assets/icons';
import { LinkProps } from 'next/link';
import CustomLink from 'components/shared/CustomLink';
import type { FoodSummary, FoodSpikeType } from 'lib/ogdb/types';
import { TimeToMealMap } from './types';
import { FoodScoreComponent } from './FoodScoreComponent';
import styles from './FoodListElement.module.css';

export const getSpikeIndicatorIcon = (
  input: FoodSpikeType,
  { className, style }: { className?: string; style?: React.CSSProperties },
) => {
  switch (input) {
    case 'high':
      return <UpArrowRed_Trend className={className} style={style} />;
    case 'medium':
      return <UpArrowYellow_Trend className={className} style={style} />;
    case 'stable':
      return <UpArrowGreen_Trend className={className} style={style} />;
    case 'low':
      return <UpArrowGreen_Trend className={className} style={style} />;
    default:
      return null;
  }
};

export const FoodListElement = ({
  food,
  ...linkProps
}: LinkProps & {
  food: FoodSummary;
}) => {
  const meal = food.meal_timing_to_show_at
    ? TimeToMealMap[food.meal_timing_to_show_at]
    : undefined;

  return (
    <CustomLink {...linkProps} className={styles.root}>
      <div className={styles.foodTextContent}>
        <h5>{food.name}</h5>
        <p>
          {food.spike_indicator ? (
            <>
              {getSpikeIndicatorIcon(food.spike_indicator, {})}
              <b>{Number(food.average_peak_glucose_levels).toFixed(0)} mg/dL</b>{' '}
              • Avg. glucose peak
            </>
          ) : null}
          {' • '} {meal ? <>{meal.title}</> : null}
        </p>
      </div>
      <FoodScoreComponent
        value={Number(food.average_score.toFixed(0))}
        className={styles.foodScoreElement}
      />
    </CustomLink>
  );
};
